export default {
  topic: 'Topic',
  subTopic: 'Subtopic',
  keySearch: 'Key Search words/phrases',
  standards: 'Standards',
  addTopic: 'Add a topic',
  addKeySearch: '+ Add Key Search words',
  addSubTopic: '+ Add a subtopic',
  editName: 'Edit Name',
  delete: 'Delete',
  addNewTopic: 'Add a new topic',
  topicName: 'Topic Name',
  topicNamePlaceholder: 'Type name here...',
  addNew: 'Add New',
  typeHere: 'Type here...',
  iroStandards: 'IRO’s Standards',
  naceSector: 'NACE Sector',
  naceCode: 'NACE Code',
  iroDescription: 'IRO Description',
  status: 'Status',
  addSector: 'Add Sector',
  titleAddModal: 'Add new IRO Standard',
  fields: {
    nacaCode: 'NACE Code',
    topic: 'Topic',
    description: 'IRO Description',
    status: 'Status',
  },
  placeholder: {
    selectCode: 'Select NACA Code',
    selectTopic: 'Type topic name',
    selectStatus: 'Select Status',
    description: 'Type IRO Description',
  },
};
